import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CodigoDescuento } from 'src/app/model/codigoDescuento';
import { CodigoDescuentoService } from 'src/app/services/api/codigoDescuento.service';
import { TokenStorageService } from 'src/app/services/api/TokenStorageService';
declare let $: any;
@Component({
  selector: 'app-codigo-descuento',
  templateUrl: './codigo-descuento.component.html',
  styleUrl: './codigo-descuento.component.css'
})
export class CodigoDescuentoComponent  implements OnInit{
  @ViewChild('myModal')
  myModal!: ElementRef;
  formCodigo!: FormGroup;
  tituloBotonGuardar:String="Nuevo Registro";
  idUsrDTO:number=0;
  esperar:boolean=false;
  codigodescuentos:CodigoDescuento[]=[];
  idCodigoDescuentoDTO:any=0;
  constructor(
    private tokenStorage: TokenStorageService,
    private codigoDescuentoService:CodigoDescuentoService,
  ){
  
  
  }

  ngOnInit(): void {
    this.formCodigo = new FormGroup({
      'txtDescripcion' : new FormControl('', Validators.required),
      'txtDescuento' : new FormControl('', Validators.required)
    });


    if (this.tokenStorage.getToken()!==null) {
      let json = JSON.stringify(this.tokenStorage.getUser());
       let data=JSON.parse(json.toString());
      
      this.idUsrDTO=data.idUsuario;
        }

        this.OnGetCodigoDescuento();
  }


  OnAbrirDialogo(idcodigo:any){
    this.idCodigoDescuentoDTO=idcodigo;
    $(this.myModal.nativeElement).modal('show'); 
  
  }


  OnGetCodigoDescuento(){
    this.codigoDescuentoService.getAllCodigoDescuento().subscribe(response =>{
      console.log(response)
      return this.codigodescuentos=response
    })
  }



OnCerrarDialogo(){
  $(this.myModal.nativeElement).modal('hide'); 
}

  OnEliminarCodigo(){
    $(this.myModal.nativeElement).modal('hide'); 

    
    this.esperar=true;
    this.codigoDescuentoService.eliminaRegistro(this.idCodigoDescuentoDTO,
    this.idUsrDTO).subscribe(response =>{
      console.log(response)
   if (response.toString()!="0"){
   
    
   
     this.esperar=false;
   //  alert("Categoria Registrada!!!");
     window.location.reload();

   }else{
   
     if (response.toString()=="0"){
       this.esperar=false;
     }
   
   }
    
      
      
     
   
    
    })



  }

  OnGuardarCodigo(){


    this.esperar=true;
    this.codigoDescuentoService.nuevoRegistro(
      this.formCodigo.value['txtDescripcion']  ,
    this.formCodigo.value['txtDescuento'],
    this.idUsrDTO).subscribe(response =>{
      console.log(response)
   if (response.toString()!="0"){
   
    
   
     this.esperar=false;
     alert("Categoria Registrada!!!");
     window.location.reload();

   }else{
   
     if (response.toString()=="0"){
       this.esperar=false;
     }
   
   }
    
      
      
     
   
    
    })



}


}
